<template>
  <v-container class="ma-0 pa-0">
    <div id="rect_container">
      <!-- <span class="asd" v-for="point in points" :key="point.value"
            
            :style="checkStyle(point)" ></span> -->
      <!-- <v-checkbox v-for="point in points" :key="point.value"
          v-model="properties[point.position]" density="compact" :value="true"
          icon color="red-darken-2" hide-details class="" :style="checkStyle(point)"></v-checkbox>
 -->


      <v-btn v-for="point in points" :key="point.value" variant="flat" icon dark
          v-model="properties[point.position]" x-small
          :color="properties[point.position] === true ? 'red' : '#fff9'"  
          @click="pointClicked(point)"
          :style="btnStyle(point)">{{ point.value }}</v-btn>

    </div>
  </v-container>
</template>

<script setup>

import { ref, inject, onMounted } from "vue";

const properties = defineModel("properties")

const props = defineProps(["featherType",])

const isFormReadOnly = ref(false) 


const points = ref([
  {
    position: `s_${props.featherType}_est`,
    left: 5,
    top: 25,
  },
  {
    position: `s_${props.featherType}_cen`,
    left: 20,
    top: 50,
  },
  {
    position: `s_${props.featherType}_int`,
    left: 35,
    top: 55,
  },
  {
    position: `d_${props.featherType}_est`,
    left: 95,
    top: 25,
  },
  {
    position: `d_${props.featherType}_cen`,
    left: 80,
    top: 50,
  },
  {
    position: `d_${props.featherType}_int`,
    left: 65,
    top: 55,
  },
  {
    position: `c_${props.featherType}_int`,
    left: 40,
    top: 83,
  },
  {
    position: `c_${props.featherType}_cen`,
    left: 50,
    top: 90,
  },
  {
    position: `c_${props.featherType}_est`,
    left: 60,
    top: 83,
  },
])


const btnStyle = (point) => {
  // return `transform: ${translationFromAngle(angle)}`
  // const x_percent = Math.cos((angle-90) * Math.PI / 180) * 200;
  // const y_percent = Math.sin((angle-90) * Math.PI / 180) * 200;
  // // return `translate(${x_percent}%,${y_percent}%)`;
  // return `translate(0,0)`;
  const styles = []


  if (point.left)
    styles.push(`left: ${point.left}%;`)
  if (point.top)
    styles.push(`top: ${point.top}%;`)
  if (point.right)
    styles.push(`right: ${point.right}%;`)
  if (point.bottom)
    styles.push(`bottom: ${point.bottom}%;`)
  return styles.join("; ")

}

// const checkStyle = (point) => {
//   const styles = []

//   styles.push("background-color: #ffffffBB")

//   if (point.left)
//     styles.push(`left: ${point.left}%;`)
//   if (point.top)
//     styles.push(`top: ${point.top}%;`)
//   if (point.right)
//     styles.push(`right: ${point.right}%;`)
//   if (point.bottom)
//     styles.push(`bottom: ${point.bottom}%;`)
//   return styles.join("; ")
// }

const pointClicked = (point) => {
  // console.log(isFormReadOnly)
  // console.log(props)
  // console.log(props.featherType)
  // console.log(properties?.[point?.position])
  if (isFormReadOnly.value) {
    return }
  properties.value[point.position] = !properties.value?.[point?.position]

  if (properties.value[point.position] === false) {
    delete properties.value[point.position]
  }

}


onMounted(() => {


  const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
    isFormReadOnly.value = svf.isReadonly.value
})

</script>

<style scoped>
#rect_container {
  display: flex;
  aspect-ratio: 800 / 320;
  position: relative;
  background: center center url('@/assets/img/gipeto.jpg');
  background-size: cover;

  /* filter: grayscale(80%); */

}


#rect_container .v-btn {
    position: absolute;
    transform:  translate(-50%, -50%) scale(.5);
    border: 3px solid white;
}
</style>
